"use strict";
/**
 * Analytics API Types
 *
 * Types for the page view analytics query and polling endpoints.
 * Used by moderator-only analytics dashboard to submit Athena queries
 * and retrieve results.
 *
 * Consumed by: lambda-secure, free-pattern-warehouse-website
 */
Object.defineProperty(exports, "__esModule", { value: true });
